import { makePlainFilters } from '../helpers/filters';
import type { TFilters } from '../types/filters';
import type { OrganizationRatingItem } from '../types/rating';

import { ProxyClient } from './client/ProxyClient';

export const getRating = async (params: TFilters): Promise<OrganizationRatingItem[]> => {
  const { data } = await ProxyClient.get<OrganizationRatingItem[]>('/ratings', {
    params: makePlainFilters(params),
  });

  return data;
};
